module.exports = __webpack_public_path__ + "img/ewm10.01c2e45a.jpg";